import React from 'react';
import * as S from "./style";
import Image from '../../../../../../app/js/components/loggedout/common/Image';
import { Link } from 'react-router-dom';
import Routes from '../../../../routes/routes';
import PlayableGroup1Img from "~images/sem/train1.png";
import PlayableGroup2Img from "~images/sem/train2.png";
import { CTAOfferButton } from '../../../../common/styled-components/styled-components';

const Playables = ({ trackPromoPageEvents, settings }) => {
  let ctaText = settings.trial_days ? `Try for free` : 'Subscribe Now';
  return (
    <S.ContainerWrapper>
      <S.HeadingText>Explore <S.HighlightText>4000+</S.HighlightText> math &amp; reading games, educational activities, and books</S.HeadingText>
      <S.PlayableWrapper>
        <S.PlayableGroupFirst>
          <Image src={PlayableGroup1Img} />
        </S.PlayableGroupFirst>
        <S.PlayableGroupSecond>
          <Image src={PlayableGroup2Img} />
        </S.PlayableGroupSecond>
      </S.PlayableWrapper>
      <S.ButtonWrapper>
        <CTAOfferButton white={true} textColor="#090A4A" fontWeight="600" hoverColor="rgb(237, 237, 249)">
          <Link to={Routes.PURCHASE_ROUTE} onClick={() => trackPromoPageEvents("Promo Page Interacted", { 'clicked_on': 'CTA5' }, true)}>
            {ctaText}
          </Link>
        </CTAOfferButton>
      </S.ButtonWrapper>
    </S.ContainerWrapper>
  )
}

export default Playables